import React, { Component } from "react";
import { Formik, Form } from "formik";
import { Link } from "react-router-dom";
import withRouter from "../withRouter.js";
import Footer from "../Component/Footer.js";
import Header from "../Component/Header.js";
import Menu from "../Component/Menu.js";
import { currentTenant, thousandsdisplay, userid } from "../Common/Credentials";
import NewJournalService from "./NewJournalService";
import {NumericFormat} from "react-number-format";
import { ToWords } from 'to-words';
import { Spinner } from "react-bootstrap";


//let jvtype=1
class DirectEntryConfirm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmjv: this.props.location.state,
      loader:false
    };
    //this.validate=this.validate.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  onSubmit(values) {
    // let sgstid, sgstpercent, sgstval;
    // let cgstid, cgstpercent, cgstval;
    // let igstid, igstpercent, igstval;
    // let vatid, vatpercent, vatval;
    // let whid, items, qty, uom, cost;
    this.setState({loader:true})
    let expenseid,expensename
    if(this.state.confirmjv.expense!==undefined){
      expenseid=this.state.confirmjv.expense.id
      expensename=this.state.confirmjv.expense.name
    }

    let dijv = {
      // debitid: this.state.confirmjv.debitid,
      // debitamt: this.state.confirmjv.debitamt,
      // creditid: this.state.confirmjv.creditid,
      // creditamt: this.state.confirmjv.creditamt,
      // narration: this.state.confirmjv.narration,
      // jvtype: this.state.confirmjv.jvtype,
      // createdBy: userid,
      // tenantId: currentTenant,
      // entrytype: this.state.confirmjv.entrytype,
      // sgstid: sgstid,
      // sgstpercent: sgstpercent,
      // sgstval: sgstval,
      // cgstid: cgstid,
      // cgstpercent: cgstpercent,
      // cgstval: cgstval,
      // igstid: igstid,
      // igstpercent: igstpercent,
      // igstval: igstval,
      // vatid: vatid,
      // vatpercent: vatpercent,
      // vatval: vatval,
      // whid: whid,
      // items: items,
      // qty: qty,
      // uom: uom,
      // cost: cost,
      // expense: this.state.confirmjv.expense,
      debt: this.state.confirmjv.debt,
      tax:this.state.confirmjv.tax,
      dtax:this.state.confirmjv.dtax,
      cred: this.state.confirmjv.cred,
      createdBy: userid,
      tenantId: currentTenant,
      naration: this.state.confirmjv.naration,
      type: this.state.confirmjv.type,
      expenseid:expenseid,
      expensename:expensename,
      debtotal:this.state.confirmjv.drcrtype===1?this.state.confirmjv.debtotal+this.state.confirmjv.taxtotal:this.state.confirmjv.cretotal,
      taxtotal:this.state.confirmjv.taxtotal,
     // dtaxtotal:this.state.confirmjv.dtaxtotal,
      cretotal: this.state.confirmjv.drcrtype===0?this.state.confirmjv.cretotal+this.state.confirmjv.taxtotal:this.state.confirmjv.debtotal,
      typeofentry:this.state.confirmjv.typeofentry,
      taxbehav:this.state.confirmjv.taxbehav,
      indtaxtype:this.state.confirmjv.indtaxtype,
      indsubtaxtype:this.state.confirmjv.indsubtaxtype,
      jvinsertiontype:this.state.confirmjv.jvinsertiontype,
      date:this.state.confirmjv.date,resentry:parseInt(0),ncentry:0

    };

    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    } else {
      NewJournalService.insertDirectEntry(dijv).then(() =>
        this.props.navigate(`/journals`, {
          message: values + "   : Combo Entry Successfull",
        })
      )
      .catch((e)=>{
        if(e.response.data.error ==="Unauthorized"){
            alert("Your Session is Lost: Please login Back to resume");
            this.props.navigate(`/`);
        }
    })
    //console.log(dijv)
    }
  }

  componentDidMount() {
    // console.log(this.state.confirmjv)
  }

  componentDidUpdate() {}

  goBack() {
    this.props.navigate(-1);
  }

  render() {
    let drjv = this.state.confirmjv.debt
    let taxjv=[]//,dtaxjv=[]
    taxjv=this.state.confirmjv.tax
    // dtaxjv=this.state.confirmjv.dtax
    let crjv = this.state.confirmjv.cred
    let jv = this.state.confirmjv
    const toWords = new ToWords();
    let amtwords = toWords.convert(parseInt(jv.cretotal));


    // let debjv = this.state.confirmjv.map(e => e.debt);
    // console.log(jv)
    return (
      <div>
        <Header />
         <Menu />
       

        <div className="content-wrapper">
          <div className="card card-info">
            {/* <div className="card-header">
              <h3 className="card-title">Confirm Entry</h3>
            </div> */}
            <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item text-secondary">
                <Link to="/accounts">Home</Link>
              </li>
              {/* <li className="breadcrumb-item text-secondary">
        <Link to={{pathname: '/journals', state: {message:''}}} >
                    Accounts
                  </Link>
        </li> */}
              <li className="breadcrumb-item active">Confirm Entry</li>
            </ol>

            <div className="text-center text-danger">{this.state.error}</div>
            <div className="card-body">
              <div className="text-center"></div>

              <Formik
                initialValues={{ jv,drjv,crjv,taxjv,amtwords }}
                onSubmit={this.onSubmit}
                validateOnChange={true}
                validate={this.validate}
                enableReinitialize={true}
              >
                {() => (
                  <Form>
                  
                    <div className="form-row">
                      <table className="table table-sm">
                        <thead style={{backgroundColor:"#e9ecef"}}>
                          <tr>
                            <td>Ledgers</td>
                            <td className="text-right"> Debit </td>
                            <td className="text-right">Credit</td>
                          </tr>
                        </thead>
                        <tbody>
                          {/* {drjv.map((e)=> */}
                          <tr key={drjv.id}>
                            <td>{drjv.name}</td>
                            <td className="text-right">
                              <NumericFormat
                                displayType={"text"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                disabled={true}
                                value={jv.drcrtype===0?jv.debtotal:jv.cretotal}
                                thousandSeparator={true}
                                thousandsGroupStyle={thousandsdisplay}
                              ></NumericFormat>
                            
                            </td>
                            
                            <td></td>
                          </tr>


{taxjv.map((e)=>
                e.name!==null?
                          <tr key={e.name.id}>
                            <td>{e.name.name}</td>
                            <td className="text-right">
                              <NumericFormat
                                displayType={"text"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                disabled={true}
                                value={jv.taxbehav===1?"(-) "+e.value:e.value}
                                thousandSeparator={true}
                                thousandsGroupStyle={thousandsdisplay}
                              ></NumericFormat>
                            
                            </td>
                            <td></td>

                          </tr>
                          :""
)}


                       
{/* {dtaxjv.map((e)=>
                e.name!==null?
                
                          <tr key={e.name.id}>
                            <td>{e.name.name}</td>
                            <td></td>
                            <td className="text-right">
                              <NumericFormat
                                displayType={"text"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                disabled={true}
                                value={jv.taxbehav===1?"(-) "+e.value:e.value}
                                thousandSeparator={true}
                                thousandsGroupStyle={thousandsdisplay}
                              ></NumericFormat>
                            
                            </td>
                            <td></td>

                          </tr>
                          :""
)} */}
                        {/* {crjv.map((e)=> */}
                          <tr key={crjv.id}>
                            <td>{crjv.name}</td>
                            <td></td>
                            <td className="text-right">
                              <NumericFormat
                                displayType={"text"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                disabled={true}
                                value={jv.drcrtype===1?jv.cretotal+jv.taxtotal:jv.debtotal+jv.taxtotal}
                                thousandSeparator={true}
                                thousandsGroupStyle={thousandsdisplay}
                              ></NumericFormat>
                            </td>
                          </tr>
  
                          <tr>
                          <td>Total</td>
                          <td className="text-right">
                              <NumericFormat
                                displayType={"text"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                disabled={true}
                                value={jv.debtotal+jv.taxtotal}
                                thousandSeparator={true}
                                thousandsGroupStyle={thousandsdisplay}
                              ></NumericFormat>
                            
                            </td>
                            
                            <td className="text-right">
                              <NumericFormat
                                displayType={"text"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                disabled={true}
                                value={jv.cretotal+jv.taxtotal}
                                thousandSeparator={true}
                                thousandsGroupStyle={thousandsdisplay}
                              ></NumericFormat> 
                              </td>
                            </tr>
                            
                            <tr>
                            <td>
                              <span className="text-blue text-bold">
                                Amount In Words :{" "}
                              </span>{" "}
                              {amtwords}
                            </td>
                            <td></td>
                            <td></td>
                          </tr>
                          <tr>
                            <td>
                              <span className="text-blue text-bold">
                                Narration :{" "}
                              </span>{" "}
                              {jv.naration}
                            </td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {/* <hr/>  */}

                    <div>
                      <div className="form-row">
                        <fieldset className="form-group col-md-12 mr-3">
                          <button className="btn hovbuttonColour btn-sm" type="submit">
                             {this.state.loader===true? <><Spinner animation="border" size="sm" />&nbsp;{"Confirm"}</>:"Confirm"}
                          </button>
                        {/* </fieldset>
                        <fieldset className="form-group col-md-2"> */}
                          <button
                            className="btn btn-sm bg-white shadow-sm"
                            type="button"
                            onClick={this.goBack}
                          >
                           <b style={{ color: "#FA5733" }}> X</b>  Close
                          </button>
                        </fieldset>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default withRouter(DirectEntryConfirm);
